import { Paper, Step, StepLabel, Stepper, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { UrlPathSegmentBuilder } from "../../../../api/url";
import MenuLayout from "../../../app/MenuLayout";
import Step1 from "./Step1";
import Step2 from "./Step2";
import { AISegmentGroup } from "../../../../store/models/segments/AISegmentGroup";

const CreateAiSegments = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [isStep1Valid, setIsStep1Valid] = useState(false);
  const [selectedModel, setSelectedModel] = useState({} as AISegmentGroup);
  const { t } = useTranslation();

  const steps = [t("segmentBuilder.ai.step1.title"), t("segmentBuilder.ai.step2.title")];

  const theme = useTheme();
  const navigate = useNavigate();

  const handleNext = () => {
    if (activeStep === 0 && !isStep1Valid) {
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      navigate(UrlPathSegmentBuilder + "?selection=aiSegments");
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleStep2Next = (value: AISegmentGroup) => {
    console.log("Received Model in handleStep2Next:", value);
    setSelectedModel(value);
    handleNext();
  };

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <Step1
            onNext={handleStep2Next}
            onValidationChange={setIsStep1Valid}
            initialValues={selectedModel}
            onBack={handleBack}
          />
        );
      case 1:
        return (
          <Step2
            selectedModel={selectedModel}
            onBack={handleBack}
          />
        );
      default:
        return t("segmentsForm.unknownStep");
    }
  };

  return (
    <div>
      <MenuLayout headline={t("segmentBuilder.title")}>
        <Paper sx={{ p: theme.spacing(2), mb: theme.spacing(2), marginTop: theme.spacing(4) }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Paper>
        <div>{getStepContent(activeStep)}</div>
      </MenuLayout>
    </div>
  );
};

export default CreateAiSegments;
